<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
                <dx-drop-down-button
                    :items="statuses"
                    text="Изменить статус"
                    display-expr="value"
                    key-expr="id"
                    @item-click="onItemClick"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';

const statuses = [
    {
        id: 1,
        value: 'Активный',
    },
    {
        id: 2,
        value: 'Архивный',
    },
];

const onItemClick = event => {
    data.status = event.itemData;
    console.log('234234', event.itemData, data);
};

const data = inject('serverData');
</script>
